import React, { useContext } from "react";
import {
  UploadDataProvider,
  UploadDataContext
} from "./UploadData/UploadDataContext";
import UploadForm from "./UploadData/UploadForm";
import MappingForm from "./UploadData/MappingForm";
import ConfirmStep from "./UploadData/ConfirmStep";
import WrappedUp from "../containers/WrappedUp";
import HorizontalStepper from "../components/Interface/Stepper";

const StepContent = () => {
  const { step } = useContext(UploadDataContext);

  let content;

  switch (step) {
    case 1:
      content = <UploadForm />;
      break;
    case 2:
      content = <MappingForm />;
      break;

    case 3:
      content = <ConfirmStep />;
      break;

    default:
      content = null;
      break;
  }

  return (
    <>
      {" "}
      <HorizontalStepper
        activeStep={step - 1}
        steps={[
          {
            title: "Sélection du fichier"
          },
          {
            title: "Configuration des colonnes"
          },
          {
            title: "Vérification avant envoi"
          }
        ]}
      />
      {content}
    </>
  );
};
const UploadDataPage = () => {
  return (
    <WrappedUp>
      <UploadDataProvider>
        <StepContent />
      </UploadDataProvider>
    </WrappedUp>
  );
};

export default UploadDataPage;
